export default __webpack_public_path__ + "3aae12ddd3944693e0720b3e6e9a1b95.jpg";